<script>
import {Response} from "@/classes/response.js";

export default {
    name: "Gateway",
    props: ["initData", "language", "contents"],
    data() {
      const urlParams = new URLSearchParams(window.location.search);
      const loginSC = urlParams.get('loginSC');

      return {
        loginSC: loginSC,
      }
    },
    computed: {
      content(){
        return this.contents.gateway
      },
    },
    created() {
        this.login()
    },
    methods: {
        login() {
            //REDIRECT
            let loginSC = null
            if(this.loginSC!==null){
              loginSC = this.loginSC
            }

            let postData = {
                "loginSC": loginSC
            }

            this.initData.loader = true
            this.$axios.post("/api/v1/user/gateway", postData)
                .then((response) => {
                    let responseData = new Response().handle(response)
                    this.initData.alerts.push({msg: responseData.msg, type: responseData.msgType})

                    if (responseData.status === true) {
                        //this.initData.user = responseData.data.user
                        //SESSION HASH STORAGE
                      this.initData.user.status = responseData.data.status
                      this.initData.user.teamName = responseData.data.teamName
                      this.initData.user.firstName = responseData.data.firstName
                      this.initData.user.isTestTeam = responseData.data.isTestTeam
                      localStorage.setItem('n120_session_hash',responseData.data.sC)
                      this.$axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('n120_session_hash')}`
                        //REDIRECT
                      setTimeout(() => {
                        this.$router.push({name: "game"})
                      }, 4000);
                    }else{
                      //TIMEOUT REDIRECT BY HISTORY
                      setTimeout(() => {
                        this.$router.go(-1);
                      }, 4000);
                    }
                })
                .catch(error => {
                  console.error(error);
                  let errorMsg = new Response().errorHandle(error.response).msg
                  for(let i=0;i<errorMsg.length;i++){
                    this.initData.alerts.push({msg: errorMsg[i].msg, type: errorMsg[i].type})
                  }
                })
                .then(() => {
                  this.initData.loader = false
                })
        },
    },
};
</script>

<template>
  <div class="container mt-5">
    <h1>{{content.title}}</h1>
    <p>{{content.txt}}</p>
    <p>{{content.redirect}}</p>
  </div>
</template>

<style scoped>
</style>